/**
 * Zone.js configuration to improve Froala editor performance
 * This file must be imported before zone.js in polyfills.ts
 */

// Disable Zone.js patching for specific events that cause performance issues in Froala editor
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  'pointerover',
  'pointerout',
  'pointermove',
  'pointerdown',
  'pointerup',
  'mouseover',
  'mouseout',
  'mousemove',
  'mousedown',
  'mouseup',
  'touchstart',
  'touchmove',
  'touchend',
  'scroll',
  'wheel',
  'dragstart',
  'dragover',
  'drop',
];

// Disable patching of certain properties to reduce Zone.js overhead
(window as any).__Zone_disable_on_property = true;
